var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from "@brushfire/ui";
import { platformAwareRedirect } from "../../../data/helpers";
import Constants from "../../../data/constants";
import Skeleton from "@material-ui/lab/Skeleton";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { useMediaQuery } from "react-responsive";
var Camp1 = "/images/Brushfire-Camp1.jpg";
var Camp2 = "/images/Brushfire-Camp2.jpg";
var ClassSeminarTraining1 = "/images/Brushfire-ClassSeminarTraining1.jpg";
var ClassSeminarTraining2 = "/images/Brushfire-ClassSeminarTraining2.jpg";
var ConcertPerformanceProduction1 = "/images/Brushfire-ConcertPerformanceProduction1.jpg";
var ConcertPerformanceProduction2 = "/images/Brushfire-ConcertPerformanceProduction2.jpg";
var Conference1 = "/images/Brushfire-Conference1.jpg";
var Conference2 = "/images/Brushfire-Conference2.jpg";
var Conference3 = "/images/Brushfire-Conference3.jpg";
var DiningPartySocial1 = "/images/Brushfire-DiningPartySocial1.jpg";
var DiningPartySocial2 = "/images/Brushfire-DiningPartySocial2.jpg";
var FitnessorSports1 = "/images/Brushfire-FitnessorSports1.jpg";
var FitnessorSports2 = "/images/Brushfire-FitnessorSports2.jpg";
var MissionorTravel1 = "/images/Brushfire-MissionorTravel1.jpg";
var MissionorTravel2 = "/images/Brushfire-MissionorTravel2.jpg";
var MissionorTravel3 = "/images/Brushfire-MissionorTravel3.jpg";
var Other1 = "/images/Brushfire-Other1.jpg";
var Other2 = "/images/Brushfire-Other2.jpg";
var Other3 = "/images/Brushfire-Other3.jpg";
var WorshipService1 = "/images/Brushfire-WorshipService1.jpg";
var WorshipService2 = "/images/Brushfire-WorshipService2.jpg";
var WorshipService3 = "/images/Brushfire-WorshipService3.jpg";
var categoryImages = {
    23: [ClassSeminarTraining1, ClassSeminarTraining2],
    14: [ConcertPerformanceProduction1, ConcertPerformanceProduction2],
    5: [Conference1, Conference2, Conference3],
    3: [Camp1, Camp2],
    13: [DiningPartySocial1, DiningPartySocial2],
    8: [FitnessorSports1, FitnessorSports2],
    10: [MissionorTravel1, MissionorTravel2, MissionorTravel3],
    12: [Other1, Other2, Other3],
    19: [WorshipService1, WorshipService2, WorshipService3],
};
var EventMapCard = function (_a) {
    var event = _a.event, isWidget = _a.isWidget, isLoading = _a.isLoading, onClick = _a.onClick, distance = _a.distance;
    var history = useWidgetHistory();
    var isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    var onClickCard = function (evt, e) {
        e.preventDefault();
        e.stopPropagation();
        platformAwareRedirect(Constants.Routes.eventStart
            .replace(":clientKey", evt.clientKey)
            .replace(":urlKey", evt.urlKey)
            .replace(":eventNumber", evt.eventNumber.toString()), isWidget, history);
    };
    var getCategoryImage = function (eventNumber, categoryId) {
        var _a;
        var options = categoryImages[categoryId];
        if (!options) {
            options = categoryImages[12];
        }
        return options[eventNumber % ((_a = options === null || options === void 0 ? void 0 : options.length) !== null && _a !== void 0 ? _a : 2)];
    };
    return (_jsx("a", __assign({ href: Constants.Routes.eventStart
            .replace(":clientKey", event.clientKey)
            .replace(":urlKey", event.urlKey)
            .replace(":eventNumber", event.eventNumber.toString()), className: "unstyled-link ".concat(isWidget ? "widget" : ""), onClick: function (evt) {
            if (onClick) {
                onClick(event, evt);
            }
            else {
                onClickCard(event, evt);
            }
        }, onKeyPress: function (evt) {
            if (evt.key === "Enter") {
                if (onClick) {
                    onClick(event, evt);
                }
                else {
                    onClickCard(event, evt);
                }
            }
        }, tabIndex: 0 }, { children: isLoading ? (_jsxs(_Fragment, { children: [_jsx(Skeleton, { animation: "wave", className: "event-card-image-loading" }), _jsxs("div", __assign({ className: "event-map-card-text-container row" }, { children: [_jsxs("div", __assign({ className: "col-8" }, { children: [_jsx(Skeleton, { animation: "wave", className: "event-card-title-loading" }), _jsx(Skeleton, { animation: "wave", className: "event-card-date-loading" })] })), _jsx("div", __assign({ className: "col-4 d-flex align-items-center justify-content-end" }, { children: _jsx(Skeleton, { animation: "wave", className: "event-card-date-loading" }) }))] }))] })) : (_jsxs("div", __assign({ className: "event-map-card" }, { children: [_jsx("div", __assign({ className: "event-map-card-image-container" }, { children: _jsx("img", { className: "event-map-card-image", alt: event.title, src: "".concat(
                        // for testing imgs locally
                        //"https://brushfire.com/images/Brushfire-Other2.jpg"
                        event.promoImageUrl
                            ? event.promoImageUrl
                            : getCategoryImage(event.eventNumber, event.categoryId)) }) })), _jsxs("div", __assign({ className: "event-map-card-text-container row" }, { children: [_jsxs("div", __assign({ className: "event-map-card-text ".concat(distance && !isMobile ? "col-8" : "col-12") }, { children: [_jsx("h6", __assign({ className: "bold m-0 event-map-card-title" }, { children: event.title })), event.dateInfoList &&
                                    event.dateInfoList.length &&
                                    event.dateInfoList.map(function (date, index) {
                                        return (_jsx("div", { children: _jsx(Text.Mini, { children: date }) }, index));
                                    }), isMobile && _jsx(Text.Mini, { children: distance }), event.remainingText && (_jsx("div", { children: _jsx(Text.Mini, { children: event.remainingText }) })), event.soldOut && _jsx("small", __assign({ className: "event-card-feature danger" }, { children: "Sold Out" })), event.isSticky && !event.soldOut && (_jsx("small", __assign({ className: "event-card-feature info" }, { children: "Featured" })))] })), distance && !isMobile && (_jsx("div", __assign({ className: "event-distance col-4" }, { children: _jsx("h6", __assign({ className: "bold m-0 event-distance-text ta-right" }, { children: distance })) })))] }))] }))) })));
};
export default EventMapCard;
